import { combineReducers } from '@reduxjs/toolkit'

import list from './listSlice'
import dashboard from './dashboardSlice'
import admins from './adminsSlice'
import collectionPoints from './collectionPointsSlice'
import affiliates from './affiliatesSlice'
import storages from './storagesSlice'
import users from './usersSlice'
import projects from './projectsSlice'
import binBox from './binBoxSlice'
import binBags from './binBagsSlice'
import projectBagDrops from './projectBagDropsSlice'
import pickups from './pickupsSlice'
import pallets from './palletsSlice'
import dispatches from './dispatchesSlice'
import affiliateRejectedMaterials from './affiliateRejectedMaterialsSlice'
import materials from './materialsSlice'
import batchRejectTypes from './batchRejectTypesSlice'
import settings from './settingsSlice'
import collectionPointBagRequests from './collectionPointBagRequestsSlice'
import fileUploads from './fileUploadsSlice'
import contacts from './contactsSlice'
import memberProducts from './memberProductsSlice'
import report from './report'
import announcements from './announcementsSlice'

const reducer = combineReducers({
    list,
    dashboard,
    admins,
    collectionPoints,
    affiliates,
    storages,
    users,
    projects,
    binBox,
    binBags,
    projectBagDrops,
    pickups,
    pallets,
    dispatches,
    affiliateRejectedMaterials,
    materials,
    batchRejectTypes,
    settings,
    collectionPointBagRequests,
    fileUploads,
    contacts,
    memberProducts,
    report,
    announcements,
})

export default reducer
